import type { PortalSummary, PortalTransaction } from '../schemas/portal';

/*
 * Mock portal data (mock-first first pass — see ADR 0009).
 *
 * These are the src/-side fixtures the mock queryFn resolves (test/factories is
 * not importable from src/). They are PLACEHOLDER DEMO VALUES, NOT a contract:
 * base entity "Acme Corp", current balance $450.00 (45000 minor units). The
 * eventual BFF contract decides the real shape; see
 * .agents/tasks/portal-fe-build/bff-and-specs-findings.md.
 *
 * Money is INTEGER MINOR UNITS; the FE formats it, never computes on it.
 */

export const PORTAL_SUMMARY_FIXTURE: PortalSummary = {
  accountName: 'Acme Corp',
  lastBilledAmountMinor: 45_000,
  currentBalanceMinor: 45_000,
  scheduledPayment: null,
  currency: 'USD',
};

export const PORTAL_TRANSACTIONS_FIXTURE: PortalTransaction[] = [
  {
    id: 'txn_0001',
    transactionDate: '2026-09-01T00:00:00Z',
    transactionType: 'Premium Charge',
    coverageMonth: '2026-09-01T00:00:00Z',
    amountMinor: 45_000,
    currency: 'USD',
    paymentStatus: 'Open',
    memo: 'Dental + Vision',
  },
  {
    id: 'txn_0002',
    transactionDate: '2026-08-04T00:00:00Z',
    transactionType: 'Payment Received',
    coverageMonth: '2026-08-01T00:00:00Z',
    amountMinor: 43_000,
    currency: 'USD',
    paymentStatus: 'Applied',
    memo: 'Auto-debit',
  },
  {
    id: 'txn_0003',
    transactionDate: '2026-08-01T00:00:00Z',
    transactionType: 'Premium Charge',
    coverageMonth: '2026-08-01T00:00:00Z',
    amountMinor: 43_000,
    currency: 'USD',
    paymentStatus: 'Paid',
    memo: 'Dental + Vision',
  },
];
